const latestSequence = {};

export default function getActionCreators(
    resourceName,
    actionTypes,
    api,
    options
) {
    let actionCreators = {
        getSingle: function (auth, params, clear = false) {
            return function (dispatch) {
                if (!latestSequence[resourceName]) {
                    latestSequence[resourceName] = {
                        controllers: {},
                        sequence: 0,
                    };
                }

                const controller = api.controller();
                const sequence = ++latestSequence[resourceName].sequence;

                Object.keys(latestSequence[resourceName].controllers).forEach(
                    (ct) => {
                        console.log('CANCEL!');
                        latestSequence[resourceName].controllers[ct].abort(
                            'Newer request'
                        );
                        delete latestSequence[resourceName].controllers[ct];
                    }
                );

                latestSequence[resourceName].controllers[sequence] = controller;

                dispatch(actionCreators.getRequest(clear));

                return api
                    .query(auth, params, controller)
                    .then(
                        (response) =>
                            dispatch(() => {
                                if (
                                    sequence <
                                    latestSequence[resourceName].sequence
                                ) {
                                    return;
                                }

                                delete latestSequence[resourceName].controllers[
                                    sequence
                                ];

                                if (response.errors) {
                                    dispatch(
                                        actionCreators.getFailure(
                                            response.errors
                                        )
                                    );
                                    return;
                                }

                                dispatch(
                                    actionCreators.getSuccess(
                                        response.data ?? response
                                    )
                                );
                            }),
                        (exception) =>
                            dispatch(actionCreators.getFailure(exception))
                    )
                    .then(
                        () => dispatch(actionCreators.getComplete()),
                        () => dispatch(actionCreators.getComplete())
                    );
            };
        },

        getFirst: function (auth, params, clear = false) {
            const controller = api.controller();

            return function (dispatch) {
                dispatch(actionCreators.getRequest(clear));

                return api
                    .query(auth, params, controller)
                    .then(
                        (response) =>
                            dispatch(
                                response.errors
                                    ? actionCreators.getFailure(response.errors)
                                    : actionCreators.getSuccess(
                                          response.data[0]
                                      )
                            ),
                        (exception) =>
                            dispatch(actionCreators.getFailure(exception))
                    )
                    .then(
                        () => dispatch(actionCreators.getComplete()),
                        () => dispatch(actionCreators.getComplete())
                    );
            };
        },

        get: function (id, auth, params, clear = false) {
            const controller = api.controller();

            if (id == null) {
                return function (dispatch) {
                    dispatch(actionCreators.getRequest(clear));

                    return api
                        .query(auth, params, controller)
                        .then(
                            (response) =>
                                dispatch(
                                    response.errors
                                        ? actionCreators.getFailure(
                                              response.errors
                                          )
                                        : actionCreators.getSuccess(response)
                                ),
                            (exception) =>
                                dispatch(actionCreators.getFailure(exception))
                        )
                        .then(
                            (response) => {
                                dispatch(actionCreators.getComplete());
                                return response;
                            },
                            () => dispatch(actionCreators.getComplete())
                        );
                };
            }

            return function (dispatch) {
                dispatch(actionCreators.getRequest(clear));

                return api
                    .get(id, auth, params)
                    .then(
                        (response) =>
                            dispatch(
                                response.errors
                                    ? actionCreators.getFailure(response.errors)
                                    : actionCreators.getSuccess(response)
                            ),
                        (exception) =>
                            dispatch(actionCreators.getFailure(exception))
                    )
                    .then(
                        (response) => {
                            dispatch(actionCreators.getComplete());
                            return response;
                        },
                        () => dispatch(actionCreators.getComplete())
                    );
            };
        },

        getRequest: function (clear) {
            let name = resourceName + '_GET_REQUEST';

            return {
                type: actionTypes[name],
                errors: null,
                data: clear,
            };
        },

        getSuccess: function (data) {
            let name = resourceName + '_GET_SUCCESS';

            return {
                data: options.hasIndividualDataWrapper ? data.data : data,
                //data: data,
                type: actionTypes[name],
            };
        },

        getComplete: function () {
            let name = resourceName + '_GET_COMPLETE';

            return {
                data: {},
                type: actionTypes[name],
            };
        },

        getFailure: function (errors, data) {
            let name = resourceName + '_GET_FAILURE';

            return {
                data: data,
                errors: errors,
                type: actionTypes[name],
            };
        },

        clear: function () {
            let name = resourceName + '_GET_CLEAR';

            return {
                data: {},
                type: actionTypes[name],
            };
        },

        cancel: function (controller) {
            return function (dispatch) {
                api.cancel(controller);
                dispatch(actionCreators.cancelRequest());
            };
        },

        cancelRequest: function () {
            let name = resourceName + '_GET_CANCEL';
            return {
                type: actionTypes[name],
            };
        },
    };

    return {
        cancel: actionCreators.cancel,
        getFirst: actionCreators.getFirst,
        getSingle: actionCreators.getSingle,
        get: actionCreators.get,
        getClear: actionCreators.clear,
    };
}
